export default __webpack_public_path__ + "77ab34b2b71badc187bef9f6de743344.png";